import type { Component } from 'vue';
import { createContext } from 'reka-ui';

/** Public context for custom filter input components */
export interface FilterInputContext {
	/** Resolved leaf input (template's filter.input or default FilterInputComponent) */
	FilterInput: Component;
	/** Default FilterInputGroup for conditional delegation — just render <component :is="FilterInputGroup" />, no props needed */
	FilterInputGroup: Component;
}

export const [injectFilterInputContext, provideFilterInputContext] =
	createContext<FilterInputContext>('FilterInput');
